import Layout from './layout/Layout'
import './css/adminlte.css'
import './css/App.css'
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';

function App(props = {}) {
  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <>      
        <Layout {...props} />
      </>
    </LocalizationProvider>
  )
}

export default App
